
import { useNavigate } from 'react-router-dom';
import { useContext, useState } from 'react';
import './style/navbar.css';
import Social from './Social';
import SearchBar from './SearchBar';
import Logo from './Logo';
import Profile from './Profile';
import { AppContext } from '../../contextApi/ContextApi';
import Navbtn from './Navbtn';
import Cart from './Cart';

export default function Navbar({ isDashboard, setDisplay=null, navRef, navbarArr }) {
  const { currentWebsite, secondary_color, primary_color, hasCategories, hasBranches, hasJobs, hasHelpdesk} = useContext(AppContext);
  // first check if navbar is exists
  const [hasNavbar] = useState(hasCategories||hasBranches||hasJobs||hasHelpdesk);
  // filter navbar buttons according to include status of each
  const [filteredNav] = useState(()=>{
    return navbarArr?.filter((val)=>{
      return val.include;
    }) || [];
  });
  const nav = useNavigate();

  // deploy filtered buttons only if navbar exists
  const deployBtns=()=>{
    if(!hasNavbar) return null;
    return filteredNav?.map((val,inx,arr)=>{
      return <Navbtn key={`navBtn_dash-${isDashboard}_${val.btnName}_${inx}`} website={currentWebsite} val={val} inx={inx} arr={arr} action={isDashboard ? ()=>{setDisplay(val.link)} : ()=>{nav(`/${currentWebsite?.settings?.domain}${val.link}`)}} isDashboard={isDashboard}/>
    })
  }
  
  if(!currentWebsite) return null;
  return (
    <div id='navbarMainDiv' ref={navRef}>
      <div id='navbarUpperDiv' style={{backgroundColor:secondary_color}}>

        <Logo action={isDashboard ? ()=>{setDisplay(0)} : ()=>{nav(`/${currentWebsite?.settings?.domain}${navbarArr[0].link}`)}}/>

        <Profile isDashboard={isDashboard}/>

        {hasCategories ? 
          <SearchBar isDashboard={isDashboard}/> :
          <div className='navbarUpperDiv_middle'></div>
        }

        {hasCategories ?
          <Cart isDashboard={isDashboard}/> :
          <div className='cart_container'></div>
        }

        <Social isDashboard={isDashboard}/>

      </div>

      <div id='navbarLowerDiv' style={{backgroundColor:!hasNavbar&&secondary_color, borderTop:!hasNavbar && `2px solid ${primary_color}`}}>
        {deployBtns()}
      </div>
    </div>
  )
}
